export enum Level {
    Beginner,     // 0
    Intermediate, // 1
    Advanced      // 2
}
